import { render, staticRenderFns } from "./QaAskModal.vue?vue&type=template&id=0cadb602&scoped=true&"
import script from "@/scripts/QA/QuestionList/components/QaAskModal?vue&type=script&lang=js&"
export * from "@/scripts/QA/QuestionList/components/QaAskModal?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cadb602",
  null
  
)

export default component.exports